import React from 'react'
import { setStorage, getStorage } from 'src/services/localStorage'
import { useAccountSelect } from './useAccount'
import { useNumbersActions, useNumbersSelect } from './useNumbers'
import { Drivers } from 'src/services/accounts'

export const useSelectedAccounts = () => {
  const [selectedAccount, setSelectedAccount] = React.useState(() => {
    const savedNumber = getStorage().selectedCommunicationAccount

    return savedNumber || null
  })

  const numbers = useNumbersSelect.numbers()
  const user = useAccountSelect.user()
  const getUserNumbers = useNumbersActions.getNumbers()
  const getUserNumbersStatus = useNumbersActions.getNumbers.status()
  const releaseNumberStatus = useNumbersActions.releaseNumber.status()
  const releaseNumberClear = useNumbersActions.releaseNumber.clear()

  const initialize = () => {
    getUserNumbers({
      id: user?.id,
      // driver: Drivers.TWILIO,
    })
  }

  React.useEffect(() => {
    if (releaseNumberStatus.isFulfilled) {
      releaseNumberClear()
      const isSelectedNumberReleased = !numbers.data.find(
        (number) => number.id === selectedAccount?.id
      )

      if (isSelectedNumberReleased) {
        setSelectedAccount(null)
        setStorage({ selectedCommunicationAccount: null })
      }
    }
  }, [releaseNumberStatus.isFulfilled, numbers])

  React.useEffect(() => {
    if (
      !selectedAccount &&
      getUserNumbersStatus.isFulfilled &&
      numbers.data.length
    ) {
      const activeAccs = numbers.data.filter(
        (n) => n.status != 'inactive' && n.driver != Drivers.RC
      )

      setSelectedAccount(activeAccs[0])
      setStorage({ selectedCommunicationAccount: activeAccs[0] })
    }
  }, [getUserNumbersStatus.isFulfilled, numbers.data, selectedAccount])

  const handleSelectAcc = (account: typeof selectedAccount) => {
    const isValid =
      account?.driver === Drivers.TWILIO && account?.status != 'inactive'

    if (isValid) {
      setSelectedAccount(account)
      setStorage({ selectedCommunicationAccount: account })
    }
  }

  return {
    handleSelectAcc,
    selectedAccount,
    initialize,
  }
}
